import {Box, Typography} from '@mui/material';
import ReactPlayer from 'react-player';
import {IMessage} from './IChannel';
import convertUrlsToLinks from '@utils/convertUrlsToLinks';

interface IProps {
	message: IMessage;
}

export default function Message({message}: IProps) {
	return (
		<div className="mb-3">
			<Box sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'background.paper' : '#2c2e38'}}
			     className="w-4/5 rounded p-1">
				{
					message.type === 'image' ? <img src={message.image} alt="" className="w-full rounded-sm"/> : ''
				}
				{
					message.type === 'video' ?
						<ReactPlayer className="w-full h-fit rounded-sm overflow-hidden" controls url={message.video}/>
						: ''
				}
				<div className="p-3">
					<Typography sx={{fontSize: (theme) => theme.typography.fontSize}} className="font-medium"
					            dangerouslySetInnerHTML={{__html: convertUrlsToLinks(message.text.replaceAll('\n', '<br/>'))}}/>
					<div className="flex flex-row justify-between">
						<Typography sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.600' : 'grey.400',
							fontSize: (theme) => theme.typography.fontSize - 2
						}}>{message.createdAt.toLocaleDateString('fa', {
							year: 'numeric',
							month: 'long',
							day: 'numeric'
						})}</Typography>
						<Typography sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.600' : 'grey.400',
							fontSize: (theme) => theme.typography.fontSize - 2
						}}>{message.createdAt.toLocaleTimeString('fa', {hour: '2-digit', minute: '2-digit'})}</Typography>
					</div>
				</div>
			</Box>
		</div>
	);
}
